/* eslint-disable */
import { getUri } from '@/config/config';
import { http } from '@/utils/http';
// import store from '../store';
// import { REQUEST_END, REQUEST_ERROR, REQUEST_START } from '../store/mutation-types';
// import { Message } from 'element-ui';

export const api = {
  successHandler: (response, urlKey) => {
    // console.log('successHandler response: ', response);
    let data = response.data
    let err = {}
    if (data.code || data.error || data.message || data.msg) {
      err.message = data.message || data.msg
      err.error = data.code || data.error
      api.handleErrorObj(err)
      if (err.status == 401 || err.status == 403) {
        // 清缓存
        window.location.href = '/login';
        return;
      }
      return Promise.reject({
        error: err.error,
        message: err.message
      })
    } else {
      return Promise.resolve(data)
    //   if (data.response && data.response.page && !data.response.page.total) {
    //     err.text = '暂无数据'
    //     err.state = -2
    //     err.status = -2
    //     err.error = 'no-content'
    //     api.handleErrorObj(err)
    //     store.commit(REQUEST_ERROR, {err, ajaxKey: urlKey})
    //     if (err.status == 403) {
    //       Message.warning('请先登录')
    //     } else {
    //       return Promise.resolve(data.response);
    //     }
    //   } else {
    //     store.commit(REQUEST_END, {ajaxKey: urlKey})
    //   }
    //   return Promise.resolve(data.response)
    }
  },

  errorHandler: (error, urlKey) => {
    // console.log('errorHandler: ', error);
    let err = {}
    err.message = error.data.message || error.message || error.statusText || '网络出问题啦';
    err.error = error.data.error || error.error;
    err.status = error.status;
    if (error.data.error_data) {
      for (let variable in error.data.error_data) {
        if (error.data.error_data.hasOwnProperty(variable)) {
          err.message = error.data.error_data[variable][0];
        }
      }
    }
    api.handleErrorObj(err, error)
    if (err.status == 401 || err.status == 403) {
      // 清缓存
      window.location.href = '/login';
      return;
    }
    return Promise.reject({
      error: err.status,
      message: err.message
    })
  },

  handleErrorObj: function (err, error) {
   if (err.error == 'no-login' || err.error == 11000) {
      err.message = '用户未登录'
      err.status = 403
    }
  },

  handleUrl: function (type, urlKey, data = {}) {
    var url = getUri(urlKey, type);
    var keys = url.match(/{[^\}]+}/g);
    if (keys && keys.length > 0) {
      keys.forEach(key => {
        var k = key.match(/(?<={).*?(?=})/g);
        var d = data[k];
        if (d === '' || d == undefined) {
          console.error(urlKey + '的path地址' + key + '参数缺少');
        } else {
          delete data[k];
          url = url.replaceAll(key, d);
        }
      })
    }
    var pathParams = data.pathParams ? data.pathParams : null
    if (pathParams) {
      for (var key in pathParams) {
        url = url.replace(key, pathParams[key])
      }
      delete data.pathParams
    }
    return url
  },

  get: (type, urlKey, data) => {
    var url = api.handleUrl(type, urlKey, data)
    return http.get(url, data).then((response) => {
      return api.successHandler(response, urlKey)
    }, (error) => {
      return api.errorHandler(error, urlKey)
    })
  },

  post: (type, urlKey, data) => {
    var url = api.handleUrl(type, urlKey, data)
    return http.post(url, data).then((response) => {
      return api.successHandler(response, urlKey)
    }, (error) => {
      return api.errorHandler(error, urlKey)
    })
  },

  put: (type, urlKey, data) => {
    var url = api.handleUrl(type, urlKey, data)
    return http.put(url, data).then((response) => {
      return api.successHandler(response, urlKey)
    }, (error) => {
      return api.errorHandler(error, urlKey)
    })
  },

  delete: (type, urlKey, data) => {
    var url = api.handleUrl(type, urlKey, data)
    if (data && Object.keys(data).length == 0) {
      data = undefined
    }
    return http.delete(url, data).then((response) => {
      return api.successHandler(response, urlKey)
    }, (error) => {
      return api.errorHandler(error, urlKey)
    })
  },

  patch: (type, urlKey, data) => {
    var url = api.handleUrl(type, urlKey, data)
    return http.get(url, data).then((response) => {
      return api.successHandler(response, urlKey)
    }, (error) => {
      return api.errorHandler(error, urlKey)
    })
  },

  upload: (type, urlKey, formdata) => {
    var url = api.handleUrl(type, urlKey, {})
    return http.upload(url, formdata).then((response) => {
      return api.successHandler(response, urlKey)
    }, (error) => {
      return api.errorHandler(error, urlKey)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js